function t(a) {
  return !!(a && a.match(/(?=^.{4,253}$)(^((?!-)[a-zA-Z0-9-]{0,62}[a-zA-Z0-9]\.)+[a-zA-Z]{2,63}$)/i));
}
export {
  t as validFQDN
};
